import { Window } from '../../../00_IMMEDIATE/Window';
import { Friendship_Chest } from './Friendship_Chest';
import FriendshipChest_Tutorial_Manager from './FriendshipChestTutorial/FriendshipChest_Tut_Manager';
import { FRIENDSHIPCHESTCARD_STATUS } from './FriendshipChest_Card';

/**
 * Friendship chest window container that pops up when you click on the icon
 * Actually uses another class that manages everything, and isn't G.Window
 * @author Sandra Koo
 */
class Window_friendshipChest extends Window {
  /**
   * constructor
   * @param {Object} parent
   */
  constructor(parent) {
    super(parent);

    let thereIsTutorial = false;
    if (OMT.feature.getFriendshipChestStory()) {
      if (G.saveState.friendshipChestDataManager.shouldTutorialCommence()) {
        thereIsTutorial = true;
      }
    }
    this.friendshipChestContainer = new Phaser.Group(game, this);
    this.friendshipChestManager = new Friendship_Chest({ // Avoiding G.Window (though its not so bad anymore!?)
      window: this,
      container: this.friendshipChestContainer,
      tutorialMode: thereIsTutorial,
    });
    this.friendshipChestManager.signals.onCloseClicked.addOnce(() => { this.closeWindow(); });
    if (thereIsTutorial) { // If theres a tutorial!?
      this.friendshipChestManager.signals.onReady.addOnce(this.readyTutorial.bind(this)); // When the friendship chest is ready, ready the tutorial
      this.friendshipChestManager.signals.onTutorialProgress.add(this.onTutorialButtonClick.bind(this)); // Hook the listener
    } else {
      this.friendshipChestManager.signals.onReady.addOnce(() => { // If theres no tutorial, just ready the hand
        this.friendshipChestManager.readyPerpetualHand();
        if (this.friendshipChestManager.currentCard.status === FRIENDSHIPCHESTCARD_STATUS.FRIEND) {
          this.friendshipChestManager.hidePerpetualHand(1);
        }
      });
    }

    if (game.state.current === 'World') {
      this.y = -G.WindowMgr.Constants.WorldVerticalOffset;
    }
  }

  closeWindow() {
    if (G.saveState.friendshipChestDataManager.getNumberOfLevelsToAppear() <= 0) {
      G.saveState.friendshipChestDataManager.setNumberOfLevelsToAppear(20);
    }
    G.saveState.save();
    G.sb('FriendshipChestCheck').dispatch();
    super.closeWindow();
  }

  /**
   * destroy override
   */
  destroy() {
    if (this.friendshipChestManager) {
      this.friendshipChestManager.destroy();
      this.friendshipChestManager = null;
    }
    if (this.tutorial) {
      this.tutorial.destroy();
      this.tutorial = null;
    }
    super.destroy();
  }

  /**
   * Creates the tutorial manager
   * Makes the cards appear smaller to allow for Gingy to talk
   */
  readyTutorial() {
    this.friendshipChestContainer.scale.set(0.84);
    this.friendshipChestContainer.y -= 35;
    this.tutorial = new FriendshipChest_Tutorial_Manager({ // steps will be managed here
      window: this,
      module: this.friendshipChestManager,
    });
  }

  /**
   * Progresses tutorial
   */
  onTutorialButtonClick() {
    if (!G.saveState.friendshipChestDataManager.getTutorialEnded()) {
      this.tutorial.progressTutorial();
    }
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.friendshipChest = Window_friendshipChest;
